<template>
  <v-container class="container__work">
    <v-row class="row__">
      <v-tabs
        fixed-tabs
        background-color="white"
        color="primary"
        v-model="tab"
        @change="changeTab"
        style="height: 42px"
        class="mt-3"
      >
        <v-tab
          class="custom-tab"
          :disabled="!verificarAccionExistente('accion:bandejaactividades')"
        >
          {{ $tc("workflow.activities") }}
        </v-tab>
        <v-tab
          class="custom-tab"
          :disabled="!verificarAccionExistente('accion:definiciones')"
        >
          {{ $tc("workflow.definitions") }}
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab" class="container__tabsItems">
        <v-tab-item>
          <v-card class="card__">
            <Activities />
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card class="card__"> </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-row>
  </v-container>
</template>

<script>
import Activities from "./Activities/Activities.vue";

export default {
  data() {
    return {
      tab: null,
    };
  },
  methods: {
    verificarAccionExistente(accion) {
      if (typeof localStorage !== "undefined") {
        const asegurables =
          JSON.parse(localStorage.getItem("asegurables")) || [];
        return asegurables.includes(accion);
      }

      return false;
    },
    changeTab(event) {
      if (event == 1) {
        this.$router.push("/FlujosTrabajo/def/niveles");
      }
    },
  },
  components: { Activities },
};
</script>

<style scoped>
.custom-tab {
  text-transform: capitalize !important;
  font-size: 16px !important;

}

.container__work {
  margin: 0px !important;
  padding: 0px !important;
  min-width: 100% !important;
}

.row__ {
  min-width: 100% !important;
}

.container__tabsItems {
  margin-top: 1em;
  min-width: 100% !important;
  background: rgba(255, 0, 0, 0) !important;
}
.card__ {
  background: rgba(255, 0, 0, 0) !important;
}
</style>
